import { useState, useContext } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DialogActions from '@mui/material/DialogActions';
import CALENDAR_ICON from "../images/Icons-calendar.svg";
import { Box } from "@mui/system";
import { LanguageContext } from '../language/LanguageContext';
import consts from '../Utilities/appConsts.json';

const CustomDatePickerInput = (props) => {
  const { onOpenPicker, openPickerLabel, ...textFieldProps } = props;

  const handleInputKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " " || event.key === "ArrowDown") {
      event.preventDefault();
      onOpenPicker();
    }
  };

  return (
    <TextField
      {...textFieldProps}
      id="custom-date-picker"
      className="calendar_picker"
      label="תאריך לידה"
      helperText={"שנוכל לפנק אותך ביום ההולדת"}
      onClick={onOpenPicker}
      onKeyDown={handleInputKeyDown}
      variant="standard"
      inputProps={{
        ...props.inputProps,
        "aria-label": openPickerLabel,
      }}
      InputLabelProps={{
        variant: "filled",
        className:"data-label"
      }}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              onClick={onOpenPicker}
              aria-label={openPickerLabel}
            >
              <Box component="img" className="color_green" src={CALENDAR_ICON} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};


export default function Calendar(props) {
  const { getTranslation } = useContext(LanguageContext);
  const openCalendarLabel = getTranslation(consts.OPEN_CALENDAR);
  const previousMonthLabel = getTranslation(consts.PREVIOUS_MONTH);
  const nextMonthLabel = getTranslation(consts.NEXT_MONTH);
  const switchMonthYearLabel = getTranslation(consts.SWITCH_MONTH_YEAR);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActionKeyDown = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  const MyActionBar = ({
  onAccept,
  onClear,
}) => {
  const { getTranslation } = useContext(LanguageContext);
  return (
      <DialogActions>
          <Button
            onClick={onClear}
            onKeyDown={(event) => handleActionKeyDown(event, onClear)}
          >
            {getTranslation(consts.CLEAR)}
          </Button>
          <Button
            onClick={onAccept}
            onKeyDown={(event) => handleActionKeyDown(event, onAccept)}
          >
            {getTranslation(consts.APPROVE)}
          </Button>
      </DialogActions>
  );
  };

  const maxDate = new Date();
  const [date, setDate] = useState(props.date);

  const handleCalendarChange = (newDate) => {
    if (!newDate || typeof newDate.toDate !== "function") {
      setDate(null);
      props.setValue(null);
      return;
    }
    setDate(newDate);
    props.setValue(newDate.toDate());
  };

  const handleDatePickerKeyDown = (event) => {
    if (event.key === "Escape") {
      handleClose();
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        value={date}
        inputFormat="DD/MM/YYYY"
        maxDate={maxDate}
        disableFuture
        onChange={(date) => handleCalendarChange(date)}
        renderInput={(params) => (
          <CustomDatePickerInput
            {...params}
            onOpenPicker={handleOpen}
            openPickerLabel={openCalendarLabel}
          />
        )}
        components={{
          ActionBar: MyActionBar
        }}
        componentsProps={{
          actionBar: { actions: ["clear", "accept"] },
          leftArrowButton: {
            tabIndex: 0,
            "aria-label": previousMonthLabel,
          },
          rightArrowButton: {
            tabIndex: 0,
            "aria-label": nextMonthLabel,
          },
          switchViewButton: {
            tabIndex: 0,
            "aria-label": switchMonthYearLabel,
          },
          dialog: {
            onKeyDown: handleDatePickerKeyDown,
          },
        }}
      />
    </LocalizationProvider>
  );
}
